var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-list-carousel-only-image-slide",style:({
    backgroundImage: _vm.backgroundImage ? `url('${ _vm.backgroundImage }')` : null,
    backgroundSize: _vm.backgroundImageMode
  })},[(_vm.qrCode)?_c('div',{staticClass:"node-list-carousel-only-image-slide--qr-code",style:({ backgroundImage: `url('${ _vm.$easyscreenRequest.lmsConnector.wrapCover(_vm.qrCode) }')` })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }